import { apiClient } from '../../axios';
import { GetPopupParams, GetPopupResponse, PopupId } from './types';

export const getPopupApi = (params?: GetPopupParams) => apiClient.get<GetPopupResponse>('/v1/popup', { params });
export const putPopupMarkAsReadApi = (popupId: PopupId) => apiClient.put(`/v1/popup/${popupId}/mark-as-read`);
